import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, mergeProps as _mergeProps, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ds-datepicker__day-value" }
const _hoisted_2 = {
  key: 0,
  class: "ds-datepicker__day-highlight"
}
const _hoisted_3 = { class: "ds-datepicker__footer" }

import { computed, onMounted, ref, useAttrs, watchEffect } from "vue";
import DatePicker, { type DatePickerDateSlotOptions, type DatePickerState } from "primevue/datepicker";
import DsIcon from "../../icon/ds-icon.vue";
import { getDatepickerPtOptions } from "./ds-datepicker/ds-datepicker-pt";
import { DsFormFieldProps } from "./general/ds-form-field.vue";
import DsFormField, { stripFormFieldProps } from "./general/ds-form-field.vue";
import DsButton from "../../button/ds-button.vue";

type SelectedModeType = "single" | "multiple" | "range";


export default /*@__PURE__*/_defineComponent({
  ...{ inheritAttrs: false },
  __name: 'ds-datepicker',
  props: /*@__PURE__*/_mergeModels({
    id: {},
    label: {},
    tooltipText: {},
    supportingText: {},
    isError: { type: Boolean },
    errorMessage: {},
    floatingError: { type: Boolean },
    disabled: { type: Boolean },
    required: { type: Boolean },
    theme: {},
    isInStorybook: { type: Boolean },
    selectionMode: {},
    hightlightedDatesFnc: { type: Function },
    inline: { type: Boolean },
    baseZIndex: {}
  }, {
    "modelValue": {},
    "modelModifiers": {},
    "isCalendarOpened": { type: Boolean, ...{ required: false, default: false } },
    "isCalendarOpenedModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["focus"], ["update:modelValue", "update:isCalendarOpened"]),
  setup(__props: any, { emit: __emit }) {

const emit = __emit;


const { class: wrapperClass, ...attrs } = useAttrs();

/**
 *  Selected date(s) in the calendar. If selectionMode is 'range', it will hold an array of dates.
 */
const modelValue = _useModel<T>(__props, "modelValue");

/**
 * Indicates if the calendar is opened.
 */
const isCalendarOpened = _useModel<boolean>(__props, "isCalendarOpened");

const props = __props;

const wrapperProps = computed(() => stripFormFieldProps(props));

const isValid = computed(() => !props.errorMessage);

const calendar = ref<InstanceType<typeof DatePicker> & DatePickerState>(null);

onMounted(() => {
    watchEffect(() => {
        calendar.value.overlayVisible = isCalendarOpened.value;
    });
});

const clearValue = () => {
    modelValue.value = null;
    isCalendarOpened.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DsFormField, _mergeProps({
    class: ["ds-datepicker", [_unref(wrapperClass), { 'ds-datepicker--inline': _ctx.inline }]]
  }, wrapperProps.value), {
    default: _withCtx(({ class: inputClasses }) => [
      _createVNode(_unref(DatePicker), _mergeProps({
        ref_key: "calendar",
        ref: calendar,
        name: _ctx.id,
        "input-id": _ctx.id,
        disabled: _ctx.disabled,
        invalid: !isValid.value,
        "selection-mode": _ctx.selectionMode,
        "show-icon": "",
        "icon-display": "input",
        breakpoint: "1024px",
        "date-format": "d. m. yy",
        "base-z-index": _ctx.baseZIndex ?? 990,
        "aria-label": "Kalendář pro výber data",
        pt: _unref(getDatepickerPtOptions)(_ctx.inline ? [] : inputClasses),
        onFocus: _cache[1] || (_cache[1] = () => emit('focus')),
        onShow: _cache[2] || (_cache[2] = () => (isCalendarOpened.value = true)),
        onHide: _cache[3] || (_cache[3] = () => (isCalendarOpened.value = false)),
        modelValue: modelValue.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((modelValue).value = $event))
      }, attrs, { unstyled: "" }), _createSlots({
        inputicon: _withCtx((iconProps) => [
          _createVNode(DsButton, {
            theme: "light",
            size: "sm",
            type: "text",
            "icon-left": "calendar",
            class: "ds-datepicker__input-icon",
            "aria-hidden": "true",
            tabindex: "-1",
            onClick: iconProps.clickCallback,
            "is-in-storybook": _ctx.isInStorybook
          }, null, 8, ["onClick", "is-in-storybook"])
        ]),
        previcon: _withCtx((prevIconProps) => [
          _createVNode(DsIcon, _mergeProps({ name: "chevron-left" }, prevIconProps, { "is-in-storybook": _ctx.isInStorybook }), null, 16, ["is-in-storybook"])
        ]),
        nexticon: _withCtx((nextIconProps) => [
          _createVNode(DsIcon, _mergeProps({ name: "chevron-right" }, nextIconProps, { "is-in-storybook": _ctx.isInStorybook }), null, 16, ["is-in-storybook"])
        ]),
        incrementicon: _withCtx((incProps) => [
          _createVNode(DsIcon, _mergeProps({ name: "chevron-up" }, incProps, { "is-in-storybook": _ctx.isInStorybook }), null, 16, ["is-in-storybook"])
        ]),
        decrementicon: _withCtx((decProps) => [
          _createVNode(DsIcon, _mergeProps({ name: "chevron-down" }, decProps, { "is-in-storybook": _ctx.isInStorybook }), null, 16, ["is-in-storybook"])
        ]),
        _: 2
      }, [
        (_ctx.hightlightedDatesFnc)
          ? {
              name: "date",
              fn: _withCtx((dateProps) => [
                _createElementVNode("span", _hoisted_1, _toDisplayString(dateProps.date.day), 1),
                (_ctx.hightlightedDatesFnc(dateProps.date))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2))
                  : _createCommentVNode("", true)
              ]),
              key: "0"
            }
          : undefined,
        (_ctx.selectionMode === 'range')
          ? {
              name: "footer",
              fn: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(DsButton, {
                    type: "interaction",
                    size: "sm",
                    onClick: clearValue,
                    "is-in-storybook": _ctx.isInStorybook
                  }, {
                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                      _createTextVNode("Zrušit filtr")
                    ])),
                    _: 1,
                    __: [5]
                  }, 8, ["is-in-storybook"]),
                  _createVNode(DsButton, {
                    type: "interaction",
                    size: "sm",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (isCalendarOpened.value = false)),
                    "is-in-storybook": _ctx.isInStorybook
                  }, {
                    default: _withCtx(() => _cache[6] || (_cache[6] = [
                      _createTextVNode("Zavřít")
                    ])),
                    _: 1,
                    __: [6]
                  }, 8, ["is-in-storybook"])
                ])
              ]),
              key: "1"
            }
          : undefined
      ]), 1040, ["name", "input-id", "disabled", "invalid", "selection-mode", "base-z-index", "pt", "modelValue"])
    ]),
    inputRight: _withCtx(() => _cache[7] || (_cache[7] = [])),
    _: 1
  }, 16, ["class"]))
}
}

})